export default __webpack_public_path__ + "static/media/holyfamily.133ea458.jpg";